import type { Preload } from './quickload.types';

export const cleanPreload = (preload: Preload) => {
  return {
    isLoading: preload.isLoading,
    start: preload.start,
    used: preload.used,
    url: preload.url,
  };
};
